<h2>Voorwaarden</h2>

<p>
    Bij InShared houden we niet van kleine lettertjes. We willen graag dat u precies weet waar u aan toe bent. Daarom
    hebben we de voorwaarden van al onze verzekeringen overzichtelijk bij elkaar gezet. Zodat u weet waar ze staan en er
    altijd even in kunt kijken. En wees niet bang, we hebben ze in 'normaal Nederlands' geschreven. Zodat voor iedereen
    duidelijk is wat er staat.
</p>

<list-flat [svg]="true" [lined]="true">
    <li>
        <ins-pdf-link
            [pdfLink]="documentsEnum.ConditionsGeneral"
            pdfLinkClass="link-flat link-flat--icon"
            pdfLinkTitle="Algemene voorwaarden"
        >
            <svg class="svg-icon svg-icon--s">
                <use href="assets/icons-ui.svg#document"></use>
            </svg>
            Algemene voorwaarden
        </ins-pdf-link>
    </li>
    <li>
        <ins-pdf-link
            [pdfLink]="documentsEnum.AnnualAward"
            pdfLinkClass="link-flat link-flat--icon"
            pdfLinkTitle="Reglement jaarbeloning"
        >
            <svg class="svg-icon svg-icon--s">
                <use href="assets/icons-ui.svg#document"></use>
            </svg>
            Reglement jaarbeloning
        </ins-pdf-link>
    </li>
</list-flat>
<br />

<ng-container *ngIf="userProductIdList.length > 0">
    <h3>Mijn voorwaarden</h3>
    <ins-terms-and-conditions-products [productIds]="userProductIdList"></ins-terms-and-conditions-products>
    <br />
</ng-container>

<ng-container *ngIf="otherProductIdList.length > 0">
    <h3>Overige voorwaarden</h3>
    <ins-terms-and-conditions-products [productIds]="otherProductIdList"></ins-terms-and-conditions-products>
</ng-container>
